document.addEventListener("DOMContentLoaded", () => {
  const collapsibles = document.querySelectorAll('[js-collapsible-outer]');
  
  collapsibles.forEach((collapsible) => {
    const header = collapsible.querySelector('[js-collapsible-header]');
    const content = collapsible.querySelector('[js-collapsible-content]');
    
    if (header && content) {
      header.addEventListener('click', () => {
        // Toggle active class on the collapsible container
        collapsible.classList.toggle('active');
        
        // Toggle max-height style on content
        if (collapsible.classList.contains('active')) {
          content.style.maxHeight = '182px';
        } else {
          content.style.maxHeight = '';
        }
      });
    }
  });
});